import { AlertConstants as BcrAlertConstants } from "best-common-react";

const AlertConstants = BcrAlertConstants.TYPES;

export default AlertConstants;
